import { render, staticRenderFns } from "./ClientAddSpa.vue?vue&type=template&id=455d75a8&"
import script from "./ClientAddSpa.vue?vue&type=script&lang=ts&"
export * from "./ClientAddSpa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455d75a8')) {
      api.createRecord('455d75a8', component.options)
    } else {
      api.reload('455d75a8', component.options)
    }
    module.hot.accept("./ClientAddSpa.vue?vue&type=template&id=455d75a8&", function () {
      api.rerender('455d75a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/ClientAddSpa.vue"
export default component.exports